import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { PopoverDisclosure, Popover } from 'ariakit/popover';
import { usePopoverStateAlpha } from './usePopoverStateAlpha.js';
export { usePopoverStateAlpha } from './usePopoverStateAlpha.js';
import { Box } from '../Box/index.js';

/* ======================================= */
// Used to increase hitbox on custom hover effect
const StyledPopover = styled(Box).withConfig({
  displayName: "PopoverAlpha__StyledPopover",
  componentId: "sc-gm90i8-0"
})(["&::before{content:'';position:absolute;margin:-", ";top:0;left:0;right:0;bottom:0;z-index:-1;}"], themeGet('space.space40'));
/* ======================================= */
/**
 * PopoverTrigger is used to toggle the Popover component.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/popover#usage)
 * - [Props](https://blockparty.endpoint.com/components/popover#props)
 * <br />
 *
 */
const PopoverTriggerAlpha = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const popover = usePopoverStateAlpha();
  return (
    /*#__PURE__*/
    // @ts-ignore - 'as' type is passed to renderProp
    React__default.createElement(PopoverDisclosure, _extends({
      state: popover
    }, props, {
      style: {
        outline: 'none'
      }
    }), popoverTriggerProps => {
      // @ts-ignore
      const dataFocusVisible = popoverTriggerProps['data-focus-visible'];
      const isFocus = dataFocusVisible === '' ? {
        _focusVisible: {
          boxShadow: 'focus'
        }
      } : null;
      return /*#__PURE__*/React__default.createElement(Box, _extends({}, isFocus, {
        borderRadius: "radiusDefault",
        display: "inline-block",
        transition: "fast",
        transitionProperty: "box-shadow"
      }, popoverTriggerProps), children);
    })
  );
};
/**
 * Popover is a non-modal dialog that floats around a trigger.
 * It's used to display contextual information to the user,
 * and should be paired with a clickable trigger element.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/popover#usage)
 * - [Props](https://blockparty.endpoint.com/components/popover#props)
 * <br />
 *
 */
const PopoverAlpha = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    state,
    ...props
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(Popover, _extends({
    state: state
  }, props), popoverBodyProps => /*#__PURE__*/React__default.createElement(StyledPopover, _extends({
    ref: forwardedRef,
    backgroundColor: "white",
    borderRadius: "radiusDefault",
    boxShadow: "medium",
    "data-test-id": "popover",
    outline: "none",
    p: "space50",
    zIndex: "popover"
  }, popoverBodyProps), children));
});

export { PopoverAlpha, PopoverTriggerAlpha };
